const AssessmentPagesFooter = () => {
	return <div className="h-[10vh] bg-[#E9F5EB]"></div>;
};

export default AssessmentPagesFooter;
